import { render, staticRenderFns } from "./DureeTravailConsultationsMDTChart.vue?vue&type=template&id=072736e6&"
import script from "./DureeTravailConsultationsMDTChart.vue?vue&type=script&lang=ts&"
export * from "./DureeTravailConsultationsMDTChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports